import React from "react";
import { CheckCircle2Icon, XCircleIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { afterItems, beforeItems } from "../../data/content";
export function BeforeAfter() {
  return <section className="bg-plum-50 px-4 py-14 sm:py-20" data-id="element-99" data-mp="26ne8fzi6n7c4">
      <div className="mx-auto max-w-5xl" data-id="element-100" data-mp="22krcbmehb094">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-plum-950 sm:text-4xl" data-id="element-101" data-mp="22lsmlono7ips">
          From Scattered Feeding Information to a{" "}
          <span className="text-mint-700" data-id="element-102" data-mp="2uc6zbhjy6ozv">Clear, Documented Clinical Workflow</span>
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg text-slate-700" data-id="element-103" data-mp="2qa3kqk1zf4ad">
          You don’t need another textbook explaining pediatric feeding concepts. You need practical tools that help you
          organize the work you’re already trained to perform.
        </p>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-104" data-mp="1esu21zqogga4">
          <div className="overflow-hidden rounded-3xl bg-white ring-2 ring-red-200" data-id="element-105" data-mp="19vaoz35pu9jr">
            <div className="bg-red-600 px-5 py-4 text-center" data-id="element-106" data-mp="176fe0d62yk01">
              <p className="font-display text-2xl font-extrabold text-white" data-id="element-107" data-mp="1c4gtko4as16r">BEFORE</p>
              <p className="text-sm font-semibold text-red-100" data-id="element-108" data-mp="1c2318n10532w">A Fragmented Process</p>
            </div>
            <ul className="space-y-3 p-5" data-id="element-109" data-mp="133r37zxt330f">
              {beforeItems.map(b => <li key={b} className="flex items-start gap-3 text-base text-slate-700" data-id="element-110" data-mp="135vg37donccu">
                  <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-111" data-mp="odjre32b0i8p" />
                  {b}
                </li>)}
            </ul>
          </div>

          <div className="overflow-hidden rounded-3xl bg-white ring-2 ring-mint-400" data-id="element-112" data-mp="fg15kwgu5zvr">
            <div className="bg-mint-600 px-5 py-4 text-center" data-id="element-113" data-mp="jgkytoyagjcm">
              <p className="font-display text-2xl font-extrabold text-white" data-id="element-114" data-mp="5fh0tju3yd8s">AFTER</p>
              <p className="text-sm font-semibold text-mint-50" data-id="element-115" data-mp="aetxsxep10p3">A Structured Professional Workflow</p>
            </div>
            <ul className="space-y-3 p-5" data-id="element-116" data-mp="2c4j009l8f6ol">
              {afterItems.map(a => <li key={a} className="flex items-start gap-3 text-base font-medium text-slate-800" data-id="element-117" data-mp="27dstuu4zezsu">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-mint-600" aria-hidden="true" data-id="element-118" data-mp="23bfq2b9spbyp" />
                  {a}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-10 text-center font-display text-xl font-extrabold text-plum-900 sm:text-2xl" data-id="element-119" data-mp="2v3etfip9nh1d">
          ONE PATHWAY. SIX OPERATIONAL STAGES. A MORE ORGANIZED CLINICAL PROCESS.
        </p>
        <div className="mt-6" data-id="element-120" data-mp="2m1noig2jve8k">
          <CtaButton label="Start Organizing My Feeding Cases — $27" data-id="element-121" data-mp="2m0vqkylhd4f4" />
        </div>
      </div>
    </section>;
}